import { connect } from 'react-redux';
import {
  isAuthorizationDeletingEntity,
  isAuthorizationFetchingGroups,
  isAuthorizationUpdatingGroup,
} from '../../reducers/analyticsApp';
import { fetchGroups } from '../../actions/authorization';
import AuthorizationView from '../../components/authorization/AuthorizationView';

const mapStateToProps = (state) => ({
  fetchingGroups: isAuthorizationFetchingGroups(state),
  updatingGroup: isAuthorizationUpdatingGroup(state),
  deleting: isAuthorizationDeletingEntity(state),
});

export default connect(mapStateToProps, { fetchGroups })(AuthorizationView);
